import type { MutableRefObject, ReactNode } from 'react';

import type { Alignment, BackgroundColor } from '../../constants';
import type { BaseComponentProps } from '../../types';
import type { CardStackCardAspectRatio } from './CardStackCard/types';

export interface CardStackBlockProps extends BaseComponentProps {
  anchorId?: string;
  backgroundColor?: BackgroundColor;
  cardMediaAspectRatio?: CardStackCardAspectRatio;
  eyebrow?: string;
  fullHeight?: boolean;
  text?: string;
  textAlignmentDesktop?: Extract<Alignment, 'Start' | 'Center' | 'End'>;
  textAlignmentMobile?: Extract<Alignment, 'Start' | 'Center' | 'End'>;
  title?: ReactNode;
}

export type UseCardStackScrollProps = {
  cardRefs: MutableRefObject<Array<HTMLElement | null>>;
  childCount: number;
  containerRef: MutableRefObject<HTMLElement | null>;
  isEnabled: boolean;
};
